"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "decode", {
  enumerable: true,
  get: function get() {
    return _decode.default;
  }
});
Object.defineProperty(exports, "encode", {
  enumerable: true,
  get: function get() {
    return _encode.default;
  }
});

var _encode = _interopRequireDefault(require("./encode"));

var _decode = _interopRequireDefault(require("./decode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }